import { TableCell, TableRow, IconButton } from '@mui/material'
import React from 'react'
import CircleCheckbox from 'src/Component/CircleCheckbox'
import eyeIcon from 'src/assets/icons/eyeIcon.png'
import deleteIcon from 'src/assets/icons/deleteIcon.png'

type DataRowProps = {
  id: number
  name: string
  email: string
  userType: string
  onViewDetailsClick: (id: number) => void
  onDeleteClick: (id: number) => void
  selected: boolean
  onSelect: (id: number) => void
}
const DataRow = ({
  id,
  name,
  email,
  userType,
  selected,
  onViewDetailsClick,
  onDeleteClick,
  onSelect,
}: DataRowProps) => {
  return (
    <TableRow
      hover
      // role='checkbox'
      // aria-checked={isItemSelected}
      tabIndex={-1}
      // key={row.id}
      // selected={isItemSelected}
      // sx={{ cursor: 'pointer' }}
    >
      <TableCell padding='checkbox'>
        {/* <Checkbox
            color='primary'
            checked={isItemSelected}
            inputProps={{
              'aria-labelledby': labelId,
            }}
          /> */}
        <CircleCheckbox checked={selected} onChange={(checked) => onSelect(id)} />
      </TableCell>
      <TableCell>{name}</TableCell>
      <TableCell>{email}</TableCell>
      <TableCell>{userType}</TableCell>
      <TableCell align='center'>
        <IconButton onClick={() => onViewDetailsClick(id)}>
          {' '}
          <img src={eyeIcon} alt='eyeIcon' />{' '}
        </IconButton>
        <IconButton onClick={() => onDeleteClick(id)}>
          {' '}
          <img src={deleteIcon} alt='deleteIcon' />{' '}
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default DataRow
